export default function scaleImage() {
  'ngInject';

  return {
    restrict: 'A',
    link($scope, $element, $attrs) {
      const scale = Number($attrs.scaleImage);
      if (!scale) {
        return;
      }
      $element.addClass('image-loading');
      $element.css('max-width', 'none');

      $element.on('load', () => {
        const height = $element[0].clientHeight;
        $element.css('height', `${height * scale}px`);
        $element.removeClass('image-loading');
      });
    },
  };
}
